import React from "react";
import { Link } from "react-router-dom";
import { Button, Grid, makeStyles, Paper, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
	actionButton: {
		width: "100%",
		maxWidth: "350px",
		color: "#004F9D",
		backgroundColor: "#fff",
		fontWeight: "bold",
		fontSize: "1.25rem",
		padding: "15px 0",
		borderRadius: "2px",
		"&:hover": {
			backgroundColor: "#D8D8D8",
		},
	},
	buttonSubText: {
		color: "#fff",
		fontSize: "0.75em",
	},
	centeredLightWhiteText: {
		textAlign: "center",
		color: "#fff",
		fontWeight: 200,
		fontSize: "1.75rem",
		marginTop: "25px",
	},
	centeredText: {
		textAlign: "center",
	},
	hero: {
		backgroundColor: "#004F9D",
		paddingTop: "50px",
		paddingBottom: "80px",
		[theme.breakpoints.down("md")]: {
			paddingLeft: "15px",
			paddingRight: "15px",
		},
	},
	heroHeaderText: {
		fontSize: "4rem",
		fontWeight: 500,
		maxWidth: "500px",
		margin: "15px auto 25px auto",
		textAlign: "center",
		lineHeight: "4.25rem",
		color: "#fff",
	},
	heroHeaderTextWithSubText: {
		fontSize: "4rem",
		fontWeight: 500,
		maxWidth: "500px",
		margin: "15px auto 25px auto",
		textAlign: "center",
		lineHeight: "4.25rem",
		color: "#fff",
		paddingBottom: "5px",
		paddingTop: "10px",
	},
	heroHeaderSubText: {
		fontSize: "1.5em",
		textAlign: "center",
		color: "#fff",
		paddingBottom: "10px",
		lineHeight: 1.2,
		marginBottom: "15px",
		marginTop: "-20px",
	},
	noUnderline: {
		textDecoration: "none",
	},
}));

interface Props {
	buttonText: string;
	buttonSubText: string;
	callToActionUrl: string;
	assetName: string;
	headerPreText: string;
	assetShortDescription: string | undefined;
}

export function Hero({
	assetName: header,
	headerPreText,
	assetShortDescription: headerSubText,
	buttonText,
	buttonSubText,
	callToActionUrl,
}: Props) {
	const classes = useStyles();
	return (
		<Grid item xs={12}>
			<Paper square className={classes.hero} elevation={2}>
				<Grid item xs={12} className={classes.centeredLightWhiteText}>
					{headerPreText}
				</Grid>
				<Grid item className={headerSubText !== undefined ? classes.heroHeaderTextWithSubText : classes.heroHeaderText}>
					{header}
				</Grid>
				{headerSubText !== undefined && (
					<Grid item className={classes.heroHeaderSubText}>
						{headerSubText}
					</Grid>
				)}
				<Grid item xs={12} className={classes.centeredText}>
					<Grid item xs={12}>
						<Link to={callToActionUrl} className={classes.noUnderline}>
							<Button className={classes.actionButton}>{buttonText}</Button>
						</Link>
					</Grid>
					<Grid item xs={12}>
						<sub className={classes.buttonSubText}>{buttonSubText}</sub>
					</Grid>
				</Grid>
			</Paper>
		</Grid>
	);
}